import React from 'react';
import './LinesResultList.css';
import {UOM_E_MULT, UOM_C_MULT, UOM_M_MULT} from './constants';

export default class LinesResultList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: "",
            globalDiscount: ""
        };
    }

    handleLineSelection = (event) => {
        const {checked, value} = event.target;
        const {selectedLines, onSelect} = this.props;

        selectedLines[value] = (checked);

        onSelect(selectedLines);
    };

    toggleLineSelection = (item) => {
        const {selectedLines, onSelect} = this.props;
        selectedLines[item.lineNumber] = !selectedLines[item.lineNumber];
        onSelect(selectedLines);
    };

    selectAllLines = () => {
        const {results} = this.props;
        const {selectedLines, onSelect} = this.props;

        for (const result of results.filter(this.filterItems)) {
            selectedLines[result.lineNumber] = true;
        }
        onSelect(selectedLines);
    };

    unselectAllLines = () => {
        const {onSelect} = this.props;
        onSelect({});
    };

    extendedPriceForPrice(price, quantity, uom, discount) {
        let mult = UOM_E_MULT;
        if (uom === 'C') {
            mult = UOM_C_MULT;
        } else if (uom === 'M') {
            mult = UOM_M_MULT;
        }

        return price * (quantity / mult) * discount;
    }

    handleItemChange(item, key, event) {
        const {onChange} = this.props;
        item[key] = event.target.value;
        onChange(item);
    }

    handleSearchFilterChange = (event) => {
        this.setState({filter: event.target.value});
    };

    handleClearFilter = (event) => {
        this.setState({filter: ""});
    };

    filterItems = (item) => {
        const {filter} = this.state;

        // if there is no search filter, return everything
        if (!filter) return true;

        var startsWithRegex = new RegExp('^' + filter, 'i');
        var containsRegex = new RegExp(filter, 'i');
        return (item.lineNumber.match(startsWithRegex) || item.catalogNumber.match(containsRegex));
    };

    setGlobalDiscount = (discount) => {
        this.setState({globalDiscount: discount});

        // if field is cleared, globally set 1
        if (!discount) {
            discount = 1;
        }

        // apply discount to all lines
        // this is not very efficient, hopefully the volume will be low enough to not be noticed
        const {results} = this.props;
        const {onChange} = this.props;
        results.filter(this.filterItems).forEach(result => {
            result.discount = discount;
            onChange && onChange(result);
        });
    };

    render() {
        const {results, newSearch, selectedLines} = this.props;
        const {filter, globalDiscount} = this.state;

        return (
            <div id="lines-result-list-container">
                <div className="float-right mb-2">
                    <div className="mb-1 text-right">
                        <a href="#"
                           onClick={(e) => {
                               e.preventDefault();
                               newSearch();
                           }}
                        >New Search</a>
                    </div>
                </div>
                <h2>Invoice Lines</h2>
                {results.length === 0 && <p className="alert alert-warning">No Lines found for Invoice#</p>}
                {results.length > 0 &&
                <div>
                    <div className="row">
                        <div className="col-4 mb-2">
                            <input type="text"
                                   className="form-control"
                                   value={filter}
                                   onChange={this.handleSearchFilterChange}
                                   placeholder="Filter by Line or Catalog#"
                            />
                        </div>
                        <div className="col-1 pl-0">
                            {filter && <button
                                type="button"
                                onClick={this.handleClearFilter}
                                className="btn btn-secondary"
                            >Clear</button>}
                        </div>
                        <div className="col-7">
                            <div className="d-flex flex-row-reverse pt-1">
                                <button type="button"
                                        className="btn btn-sm btn-secondary"
                                        onClick={this.selectAllLines}
                                >Select All
                                </button>

                                <button type="button"
                                        className="btn btn-sm btn-secondary mr-1"
                                        onClick={this.unselectAllLines}
                                >Unselect All
                                </button>
                            </div>
                        </div>
                    </div>
                    <table className="table table-sm table-bordered">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Line Number</th>
                            <th>ABB Catalog#/SKU</th>
                            <th>U/M</th>
                            <th>Quantity</th>
                            <th>Price</th>
                            <th>
                                Discount
                                <input type="text"
                                       className="form-control form-control-sm"
                                       value={globalDiscount}
                                       onChange={(e) => {
                                           this.setGlobalDiscount(e.target.value);
                                       }}
                                />
                            </th>
                            <th>Extended Price</th>
                        </tr>
                        </thead>
                        <tbody>
                        {results && results.sort((a, b) => {
                            const aInt = parseInt(a.lineNumber, 10);
                            const bInt = parseInt(b.lineNumber, 10);
                            if (aInt > bInt) return 1;
                            if (aInt < bInt) return -1;
                            return 0;
                        })
                            .filter(this.filterItems)
                            .map((item, index) => {
                                return (
                                    <tr key={`${item.lineNumber}-${index}`}
                                        className={(selectedLines[item.lineNumber]) ? 'selected' : ''}
                                        onClick={() => {
                                            this.toggleLineSelection(item)
                                        }}
                                    >
                                        <td>
                                            <input type="checkbox"
                                                   value={item.lineNumber}
                                                   onChange={this.handleLineSelection}
                                                   checked={(!!selectedLines[item.lineNumber])}
                                            />
                                        </td>
                                        <td>{item.lineNumber}</td>
                                        <td>{item.catalogNumber}</td>
                                        <td>{item.unitOfMeasure}</td>
                                        <td>
                                            <input type="text"
                                                   className="form-control"
                                                   value={item.quantity}
                                                   onChange={(event) => {
                                                       this.handleItemChange(item, 'quantity', event)
                                                   }}
                                                   onClick={(event) => {
                                                       if (selectedLines[item.lineNumber]) {
                                                           event.stopPropagation();
                                                       }
                                                   }}
                                            />
                                        </td>
                                        <td>
                                            <input type="text"
                                                   className="form-control"
                                                   value={item.price}
                                                   onChange={(event) => {
                                                       this.handleItemChange(item, 'price', event)
                                                   }}
                                                   onClick={(event) => {
                                                       if (selectedLines[item.lineNumber]) {
                                                           event.stopPropagation();
                                                       }
                                                   }}
                                            />
                                        </td>
                                        <td>
                                            <input type="text"
                                                   className="form-control"
                                                   value={item.discount}
                                                   onChange={(event) => {
                                                       this.handleItemChange(item, 'discount', event)
                                                   }}
                                                   onClick={(event) => {
                                                       if (selectedLines[item.lineNumber]) {
                                                           event.stopPropagation();
                                                       }
                                                   }}
                                            />
                                        </td>
                                        <td>
                                            {this.extendedPriceForPrice(item.price, item.quantity, item.unitOfMeasure, item.discount)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                }
            </div>
        );
    }
}